<template>
  <div class="">
    <div class="">
      <div class="mb-5 level">
        <h3>Grupo Opciones</h3>
        <b-tooltip label="Agregar">
          <b-button
            type="is-dark"
            size="is-small"
            @click="isImageModalActive = true"
          >
            <font-awesome-icon :icon="['fas', 'plus']" />
          </b-button>
        </b-tooltip>
      </div>
      <hr />
      <div class v-if="!loading_product_form">
        <div v-if="product_form_list.length > 0">
          <ProductFormItem
            class="product_form_list"
            v-for="product_form_item in product_form_list"
            :key="product_form_item.id"
            :product-form-item="product_form_item"
            @productFormUpdate="getProductFormList"
          ></ProductFormItem>
        </div>
        <div v-else>
          <p>No cuenta con grupo de opciones</p>
        </div>
      </div>
    </div>
    <b-modal v-model="isImageModalActive" :width="468" scroll="keep">
      <div class="card">
        <div class="card-content py-5">
          <h3 class="is-size-4 has-text-weight-bold mb-5">
            Agregar Grupo de Opciones
          </h3>

          <hr />
          <div class="">
            <b-field label="Activo">
              <b-switch v-model="form.is_active" type="is-success"></b-switch>
            </b-field>
            <b-field
              label="Nombre del área"
              :custom-class="$v.form.name.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.form.name.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.form.name.required && $v.form.name.$error
                }
              ]"
            >
              <b-input v-model="form.name"></b-input>
            </b-field>
            <b-field
              label="Texto de ayuda"
              :custom-class="$v.form.help_text.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.form.help_text.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.form.help_text.required && $v.form.help_text.$error
                }
              ]"
            >
              <b-input v-model="form.help_text"></b-input>
            </b-field>
            <b-field
              label="Posición"
              :custom-class="$v.form.position.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.form.position.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.form.position.required && $v.form.position.$error
                }
              ]"
            >
              <b-input v-model="form.position" type="number" min="0"></b-input>
            </b-field>
            <b-field label="Obligatorio">
              <b-switch v-model="form.mandatory" type="is-success"></b-switch>
            </b-field>
            <b-field label="Tipo de opción">
              <b-select
                placeholder="Seleccione una opción"
                expanded
                v-model="form.type_option"
              >
                <!-- <option value="B">
                  Elección Switch
                </option> -->
                <option value="Q">
                  Elección Cantidad
                </option>
                <option value="R">
                  Elección Única
                </option>
                <option value="C">
                  Elección Multiple
                </option>
              </b-select>
            </b-field>
          </div>
          <hr />
          <div v-if="form.type_option != 'B' && form.type_option != 'R'">
            <b-field label="Cantidad Mínima">
              <b-input
                v-model="form.min_quantity"
                type="number"
                min="0"
              ></b-input>
            </b-field>
            <b-field label="Cantidad Máxima" class="mb-2">
              <b-input v-model="form.max_quantity" type="number" min="0">
              </b-input>
            </b-field>
            <hr />
          </div>
          <div
            class="is-flex is-justify-content-flex-end w-full is-align-items-center"
          >
            <div>
              <Button
                variant="gray"
                @click.native="isImageModalActive = false"
                >Cerrar</Button
              >
            </div>
            <div class="ml-3">
              <Button
                variant="main"
                :spinner="loading"
                @click.native="submitProductForm"
                >Crear</Button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import ErrorsDJ from '@/mixins/error'
import ProductFormItem from '@/components/product/ProductFormItem'
import Button from '@/components/form/Button'
import ProductService from '@/services/ProductService'
export default {
  name: 'ProductFormCreate',
  components: {
    ProductFormItem,
    Button
  },
  mixins: [ErrorsDJ],
  data() {
    return {
      loading: null,
      form: {
        name: '',
        mandatory: false,
        max_quantity: 0,
        min_quantity: 0,
        type_option: 'R',
        position: 1,
        is_active: true,
        help_text: ''
      },
      product_form_list: [],
      loading_product_form: null,
      isImageModalActive: false
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      help_text: {
        required
      },
      position: {
        required
      }
    }
  },
  created() {
    this.getProductFormList()
  },
  methods: {
    async getProductFormList() {
      this.loading_product_form = true
      const response = await ProductService.getFormList(this.$route.params.id)
      this.loading_product_form = false
      this.product_form_list = response.data
    },
    resetProductFormCreate() {
      Object.assign(this.form, {
        product: null,
        name: '',
        mandatory: false,
        max_quantity: null,
        min_quantity: null,
        type_option: 'B',
        position: 1,
        is_active: true
      })
    },
    async submitProductForm() {
      this.$v.$touch()
      this.loading = true
      try {
        await ProductService.postFormList(this.$route.params.id, this.form)
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se guardó correctamente.'
        })
        this.getProductFormList()
        this.form = {
          name: '',
          mandatory: false,
          max_quantity: 0,
          min_quantity: 0,
          type_option: 'B',
          position: 1,
          is_active: true,
          help_text: ''
        }
        this.isImageModalActive = false
      } catch (error) {
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    },
    productFormUpdate(productFormItem, ProductFormItemUpdate) {
      Object.assign(productFormItem, ProductFormItemUpdate)
    }
  }
}
</script>
<style lang="scss">
.product_form_list {
  margin-bottom: 15px;
}
</style>
